import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const primary = {
  50: '#f2f2f6',
  100: '#F6F8FD',
  200: '#D7DDED',
  300: '#61638f',
  400: '#2A3A5A',
  500: '#151f33',
  600: '#375081',
  700: '#000234',
  800: '#000229',
  900: '#00011e',
  950: '#000113'
}
const MyPreset = definePreset(Aura, {
  components: {
    button: {
      root: {
        paddingX: '1rem',
        paddingY: '0.5rem',
        primary: {
          background: 'var(--primary-color)',
          hoverBackground: 'var(--primary-color)',
          activeBackground: 'var(--primary-color)',
          borderColor: 'var(--primary-color)',
          hoverBorderColor: 'var(--primary-color)',
          activeBorderColor: 'var(--primary-color)',
          color: 'var(--primary-color-text, #ffffff)',
          hoverColor: 'var(--primary-color-text, #ffffff)',
          activeColor: 'var(--primary-color-text, #ffffff)',
          focusRing: {
            color: 'var(--primary-color)',
            shadow: 'none'
          }
        }
      },
      outlined: {
        primary: {
          borderColor: 'var(--primary-color)',
          color: 'var(--primary-color)'
        }
      }
    }
  },
  semantic: {
    primary: {
      50: primary[50],
      100: primary[100],
      200: '#d7dded',
      300: primary[300],
      400: primary[400],
      500: primary[500],
      600: primary[600],
      700: primary[700],
      800: primary[800],
      900: primary[900],
      950: primary[950]
    },
    formField: {
      background: '#ffffff',
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
      focusBorderColor: 'transparent',
      invalidBorderColor: 'transparent',
      borderRadius: 'var(--input-border-radius, 24px)',
      shadow: '0 0 4px rgba(0, 0, 0, 0.12)',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: '0 0 6px rgba(0, 0, 0, 0.18)'
      }
    },
    colorScheme: {
      light: {
        surface: {
          700: '#1e293b' // Text color
        }
      }
    }
  }
})

export default MyPreset
